export default (values, value) => value.length > 0
